import PropTypes from "prop-types";
import styled from "theme/libs/styled";

const StyledWrapper = styled("div")``;

const Row = ({ as, display, flexDirection, width, ...rest }) => (
    <StyledWrapper as={as || "div"} display={display} flexDirection={flexDirection} width={width} {...rest} />
);

Row.propTypes = {
    as: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    display: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    flexDirection: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

Row.defaultProps = {
    as: undefined,
    display: "flex",
    flexDirection: "row",
    width: "100%",
};

export default Row;
